import {
  MediaRendererProps,
  MediaObject,
  MediaConfiguration,
} from "@zoralabs/nft-components";
import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const HTMLRenderer = (props) => {
    return (
        <iframe {...props} width="100%" height="800px" style={{ border: 0 }}>
          IFrame support needed to see PDF
        </iframe>
    );
};

const ZoraRenderer = ({metadata, contentURI}) => { 
    const customRenderers = {
        "uri:text/html": {
            hasLoading: true,
            renderer: HTMLRenderer,
        },
    };
    console.log('content URI=', contentURI);
    return (
        <iframe sandbox="allow-scripts allow-same-origin" height="519" width="100%" aria-describedby="undefineddescription" alt="testing" src={contentURI} className="zora-mediaObject css-hnzuw7 zora-mediaObject--mediaLoaded zora-mediaObject--isFullPage" style={{border: 0}}></iframe>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZoraRenderer);
